import { globalVariables } from "helper/globalVariables";
import { useForm } from "react-hook-form";
import { TextInput } from "../../shared/Components/textInput";
import { loginResolver } from "validators/UserValidation";
import { Button } from "../../shared/Components/button";
import { useRef, useState } from "react";
import { client } from "helper/apolloConfig";
import { loginMutation } from "redux/features/authSlice/authGql";
import { useDispatch } from "react-redux";
import {
  setAuthToken,
  setEmail,
  setUser,
} from "redux/features/authSlice/AuthSlice";
import AuthLayout from "shared/Components/authLayout";

const Login = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: loginResolver,
    defaultValues: {
      email: "",
      password: "",
    },
  });
  const modalRef = useRef();
  const [apiData, setApiData] = useState({
    title: "",
    desc: "",
    type: "pending",
  });
  const [loading, setLoading] = useState();
  const dispatch = useDispatch();

  const handleLogin = async (credentials) => {
    setLoading(true);

    const payload = {
      email: credentials?.email,
      password: credentials?.password,
    };
    try {
      const result = await client.mutate({
        mutation: loginMutation,
        variables: { data: payload },
      });

      const loginData = result?.data?.login;
      dispatch(setUser(loginData));
      dispatch(setEmail(credentials?.email));
      dispatch(setAuthToken(loginData?.access_token));
      setLoading(false);
    } catch (error) {
      modalRef.current.openModal();

      // Check if error is about blocked user
      let errorTitle = globalVariables.error;
      let errorDesc = error?.message;

      if (error?.message && error.message.toLowerCase().includes('user is blocked')) {
        errorTitle = "Oops!";
        errorDesc = (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
            <span>User is blocked</span>
            <span>(Please contact admin for assistance)</span>
            <a
              href="mailto:k9scentgames.fun@gmail.com"
              style={{ color: '#5A1E66', textDecoration: 'underline', marginTop: '4px' }}
            >
              k9scentgames.fun@gmail.com
            </a>
          </div>
        );
      }

      setApiData({
        ...apiData,
        title: errorTitle,
        desc: errorDesc,
        type: "pending",
      });
      setLoading(false);
    }
  };

  return (
    <AuthLayout ref={modalRef} apiData={apiData}>
      <span className="pt-4 text-gray-900 font-semibold text-3xl">
        {globalVariables.logIn}
      </span>
      <span className="pt-3 text-gray-500 font-regular text-base max-[400px]:w-[90%]">
        {globalVariables.welcomeBack}
      </span>
      <div className="mt-6" />
      <form
        onSubmit={handleSubmit(handleLogin)}
        className="flex flex-col justify-center items-center max-[400px]:w-[90%]"
      >
        <TextInput
          register={register}
          name="email"
          label={globalVariables.email}
          placeholder={globalVariables.enterEmail}
          errorMsg={errors.email?.message}
          width="w-[358px] lg:w-[360px] max-[400px]:w-[100%]"
          type="email"
          textTransform="normal-case"
        />
        <div className="mt-4" />
        <TextInput
          register={register}
          name="password"
          width="w-[358px] lg:w-[360px] max-[400px]:w-[100%]"
          label={globalVariables.password}
          placeholder={globalVariables.tempPassword}
          errorMsg={errors.password?.message}
          type="password"
          textTransform="normal-case"
        />
        <div className="mt-2 flex justify-end mr-5 w-full">
          <a href="/forgotPassword">
            <span className="text-sm text-primary font-semibold">
              {` ${globalVariables.forgotPassword}`}
            </span>
          </a>
        </div>
        <div className="mt-6" />
        <Button
          width="w-[358px] lg:w-[360px] max-[400px]:w-[100%]"
          label={globalVariables.logIn}
          disabled={loading}
        />
      </form>
      <div className="mt-4" />
      <span className="text-sm text-gray-600 font-regular">
        {globalVariables.dontHaveAccount}
        <a href="/signup">
          <span className="text-sm text-primary font-semibold">
            {` ${globalVariables.signUp}`}
          </span>
        </a>
      </span>
    </AuthLayout>
  );
};

export default Login;
